export default __webpack_public_path__ + "static/media/gothamChess.a886a6a1.webp";